// src/components/UpdateBanner.js
//
// SECTION 517 (2026-09-29, overnight; item 8). A page keeps the code it loaded until it is reloaded, so a member working
// when a fix is deployed keeps the old screen (Bob met exactly this at 01:36Z: the old Box 1 after the new one was live).
// Every five minutes, and whenever the window regains focus, this reads the site's asset-manifest.json (served no-cache)
// and compares the main bundle it names with the one this page is running. When they differ it says so and offers
// Reload. It never reloads by itself in the middle of a page - the member may have unsaved work.
//
// SECTION 522 (2026-09-30). THE PERMANENT FIX BEYOND F5. Bob: "Whats the permanent fix beyond f5". The banner still
// asked the member to act. Now the next time he moves to another page from the menu - the moment the page he was on
// is being closed anyway, so nothing typed on it survives either way - a stale tab loads the new version and lands on
// the page he clicked (navigateFresh). The check also runs when the tab becomes visible again and every two minutes.
// Nobody has to know about F5.
import React, { useEffect, useState } from 'react';

const RESUME_KEY = 'ycp.resumePage';
let staleKnown = false;          // set once the live bundle is seen to differ from this page's
const listeners = new Set();

function runningBundle() {
  const el = typeof document !== 'undefined' ? document.querySelector('script[src*="/static/js/main."]') : null;
  const m = el ? /\/static\/js\/(main\.[^/]+\.js)/.exec(el.getAttribute('src') || '') : null;
  return m ? m[1] : '';
}

function checkNow() {
  const mine = runningBundle();
  if (!mine || staleKnown) return Promise.resolve(staleKnown);
  return fetch('/asset-manifest.json', { cache: 'no-store' })
    .then(r => (r.ok ? r.json() : null))
    .then(j => {
      const live = j && j.files && typeof j.files['main.js'] === 'string' ? j.files['main.js'].split('/').pop() : '';
      if (live && live !== mine) { staleKnown = true; listeners.forEach(f => f(true)); }
      return staleKnown;
    })
    .catch(() => staleKnown);
}

// Menu navigation. When this tab is running an old version, reload into the new one and land on `page`;
// otherwise navigate normally. Returns nothing; `go` is the ordinary setPage.
export function navigateFresh(page, go) {
  if (staleKnown) {
    try { window.sessionStorage.setItem(RESUME_KEY, String(page)); } catch (e) { /* storage blocked: lands on the role's page */ }
    window.location.reload();
    return;
  }
  go(page);
  checkNow();   // look again in the background, so the NEXT click is current
}

// The page a reload-on-navigation was headed for, once. Null when there is none.
export function takeResumePage() {
  try {
    const p = window.sessionStorage.getItem(RESUME_KEY);
    if (p) window.sessionStorage.removeItem(RESUME_KEY);
    return p || null;
  } catch (e) { return null; }
}

export default function UpdateBanner() {
  const [stale, setStale] = useState(false);
  useEffect(() => {
    if (!runningBundle()) return undefined;   // development server, or an unrecognised build: nothing to compare
    const on = (v) => setStale(v);
    listeners.add(on);
    checkNow();
    const t = setInterval(checkNow, 2 * 60 * 1000);
    const onFocus = () => checkNow();
    const onVis = () => { if (document.visibilityState === 'visible') checkNow(); };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVis);
    return () => { listeners.delete(on); clearInterval(t); window.removeEventListener('focus', onFocus); document.removeEventListener('visibilitychange', onVis); };
  }, []);
  if (!stale) return null;
  return (
    <div role="status" style={{ position: 'fixed', left: 16, right: 16, bottom: 16, zIndex: 2000, background: '#0D1B2A',
      border: '2px solid #E8A020', borderRadius: 8, padding: '10px 14px', color: '#DCE7F2', display: 'flex', gap: 12,
      alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', fontSize: 13 }}>
      <span>A newer version of the platform is ready. It loads by itself the next time you choose a page from the menu - or save your work and reload now.</span>
      <button className="btn btn-primary btn-sm" onClick={() => window.location.reload()}>Reload now</button>
    </div>
  );
}
